import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const client = axios.create({
  baseURL: window.BASE_URL,
});

const getHeader = () => {
  let token = localStorage.getItem("Token");
  return {
    "Content-Type": "application/json",
    Authorization: "Bearer " + token,
  };
};
//Users
export async function UsersRegister(model) {
  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Users/Register", data, {
      headers: { "Content-Type": "application/json" },
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
export async function UsersActiveForgetPass(model) {
  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Users/ActiveForgetPass", data, {
      headers: { "Content-Type": "application/json" },
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
export async function UsersForgetPass(model) {
  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Users/ForgetPass", data, {
      headers: { "Content-Type": "application/json" },
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function UsersActiveRegister(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Users/ActiveRegister", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
export async function UsersReSendCode() {
  let header = getHeader();

  try {
    const response = await client.get("/Users/ReSendCode", {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function UsersChangePassword(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Users/ChangePassword", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}


export async function UsersToken(model) {
  let data = { username: model.username, password: model.password };
  data = JSON.stringify(data);
  try {
    const response = await client.post("/Users/Token", data, {
      headers: {
        "Content-Type": "application/json-patch+json",
      },
    });
    localStorage.setItem("Token", response.data.access_token);
    localStorage.setItem("refresh_token", response.data.refresh_token);
    return response;
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function UsersGetMyUserByToken() {
  let header = getHeader();

  try {
    const response = await client.get("/Users/GetMyUserByToken", {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function UsersFilter(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Users/Filter", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
export async function CompetitorGetIdentityCompetitorUser(id) {
  let header = getHeader();

  try {
    const response = await client.get(
      "/Competitor/GetIdentityCompetitorUser/" + id,
      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
export async function CompetitorGetIdentityUserCompetitor(id) {
  let header = getHeader();

  try {
    const response = await client.get(
      "/Competitor/GetIdentityUserCompetitor/" + id,
      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function UsersDelete(id) {
  let header = getHeader();

  try {
    const response = await client.post("/Users/Delete/" + id, undefined, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function UsersChangeActive(id) {
  let header = getHeader();

  try {
    const response = await client.post("/Users/ChangeActive/" + id, undefined, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function UsersUpdate(model, id) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Users/Update/" + id, data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function UsersAddExpDay(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Users/AddExpDay", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function UsersCreate(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Users/Create", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

//Users

////////////////////////////////////////////////////////////////////////////////////////////

//Supplier
export async function SupplierFilterSupplier(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Supplier/FilterSupplier", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SupplierDeleteSupplier(id) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/Supplier/DeleteSupplier/" + id,
      undefined,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SupplierCreateSupplier(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Supplier/CreateSupplier", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SupplierUpdateSupplier(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Supplier/UpdateSupplier", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

//Supplier
//ShowSupplier

export async function SupplierGetSupplier() {
  let header = getHeader();

  try {
    const response = await client.get("/Supplier/GetSupplier", {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
export async function SupplierGetSupplierBankById(id) {
  let header = getHeader();

  try {
    const response = await client.get("/Supplier/GetSupplierBankById/" + id, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
export async function SupplierGetSupplierWarehouseById(id) {
  let header = getHeader();

  try {
    const response = await client.get(
      "/Supplier/GetSupplierWarehouseById/" + id,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

//ShowSupplier

//SupplierType
export async function SupplierFilterSupplierType(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Supplier/FilterSupplierType", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SupplierDeleteSupplierType(id) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/Supplier/DeleteSupplierType/" + id,
      undefined,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SupplierCreateSupplierType(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Supplier/CreateSupplierType", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SupplierUpdateSupplierType(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Supplier/UpdateSupplierType", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

//SupplierType

//SupplierWarehouse
export async function SupplierFilterSupplierWarehouse(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post(
      "/Supplier/FilterSupplierWarehouse",
      data,
      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SupplierDeleteSupplierWarehouse(id) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/Supplier/DeleteSupplierWarehouse/" + id,
      undefined,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SupplierCreateSupplierWarehouse(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post(
      "/Supplier/CreateSupplierWarehouse",
      data,
      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SupplierUpdateSupplierWarehouse(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post(
      "/Supplier/UpdateSupplierWarehouse",
      data,
      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

//SupplierWarehouse

//SupplierBank
export async function SupplierFilterSupplierBank(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Supplier/FilterSupplierBank", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SupplierDeleteSupplierBank(id) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/Supplier/DeleteSupplierBank/" + id,
      undefined,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SupplierCreateSupplierBank(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Supplier/CreateSupplierBank", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SupplierUpdateSupplierBank(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Supplier/UpdateSupplierBank", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

//SupplierBank
//SupplierWarehouseType

export async function SupplierGetIdentityWarehouseUser(id) {
  let header = getHeader();

  try {
    const response = await client.get(
      "/Supplier/GetIdentityWarehouseUser/" + id,
      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
export async function SupplierSetIdentityWarehouseUser(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post(
      "/Supplier/SetIdentityWarehouseUser",
      data,
      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SupplierFilterWarehouseType(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Supplier/FilterWarehouseType", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SupplierDeleteWarehouseType(id) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/Supplier/DeleteWarehouseType/" + id,
      undefined,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SupplierCreateWarehouseType(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Supplier/CreateWarehouseType", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SupplierUpdateWarehouseType(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Supplier/UpdateWarehouseType", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

//SupplierWarehouseType
////////////////////////////////////////////////////////////////////////////////////////////

//Product
export async function ProductFilterProduct(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/FilterProduct", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
export async function ProductFilterProductsDontColor() {
  let header = getHeader();

  try {
    const response = await client.get("/Product/FilterProductsDontColor", {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
export async function ProductFilterProducts(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/FilterProducts", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
export async function CompetitorPriceLastPriceProduct() {
  let header = getHeader();

  try {
    const response = await client.get("/CompetitorPrice/LastPriceProduct", {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductChangeActiveProduct(id) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/Product/ChangeActiveProduct/" + id,
      undefined,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductDeleteProduct(id) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/Product/DeleteProduct/" + id,
      undefined,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductCreateProduct(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/CreateProduct", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
export async function ProductCreateProductColor(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/CreateProductColor", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductUpdateProduct(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/UpdateProduct", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductChangeOrderProduct(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/ChangeOrderProduct", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
//Product

//Type

export async function ProductFilterType(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/FilterType", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductDeleteType(id) {
  let header = getHeader();

  try {
    const response = await client.post("/Product/DeleteType/" + id, undefined, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductChangeOrderType(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/ChangeOrderType", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductCreateType(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/CreateType", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductUpdateType(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/UpdateType", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
//Type

//Series

export async function ProductFilterSeries(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/FilterSeries", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductDeleteSeries(id) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/Product/DeleteSeries/" + id,
      undefined,
      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductChangeOrderSeries(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/ChangeOrderSeries", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductCreateSeries(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/CreateSeries", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductUpdateSeries(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/UpdateSeries", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
//Series

//SeriesEnd

export async function ProductFilterSeriesEnd(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/FilterSeriesEnd", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductDeleteSeriesEnd(id) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/Product/DeleteSeriesEnd/" + id,
      undefined,
      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductChangeOrderSeriesEnd(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/ChangeOrderSeriesEnd", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductCreateSeriesEnd(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/CreateSeriesEnd", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductUpdateSeriesEnd(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/UpdateSeriesEnd", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
//SeriesEnd

//Network

export async function ProductFilterNetwork(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/FilterNetwork", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductDeleteNetwork(id) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/Product/DeleteNetwork/" + id,
      undefined,
      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductChangeOrderNetwork(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/ChangeOrderNetwork", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductCreateNetwork(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/CreateNetwork", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductUpdateNetwork(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/UpdateNetwork", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
//Network

//Rom

export async function ProductFilterRom(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/FilterRom", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductDeleteRom(id) {
  let header = getHeader();

  try {
    const response = await client.post("/Product/DeleteRom/" + id, undefined, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductChangeOrderRom(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/ChangeOrderRom", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductCreateRom(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/CreateRom", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductUpdateRom(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/UpdateRom", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
//Rom

//Ram

export async function ProductFilterRam(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/FilterRam", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductDeleteRam(id) {
  let header = getHeader();

  try {
    const response = await client.post("/Product/DeleteRam/" + id, undefined, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductChangeOrderRam(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/ChangeOrderRam", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductCreateRam(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/CreateRam", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductUpdateRam(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/UpdateRam", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
//Ram

//Country

export async function ProductFilterCountry(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/FilterCountry", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductChangeOrderCountry(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/ChangeOrderCountry", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductDeleteCountry(id) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/Product/DeleteCountry/" + id,
      undefined,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductCreateCountry(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/CreateCountry", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductUpdateCountry(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/UpdateCountry", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

//Country

//Color

export async function ProductDeleteColor(id) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/Product/DeleteColor/" + id,
      undefined,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductChangeOrderColor(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/ChangeOrderColor", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductCreateColor(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/CreateColor", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductUpdateColor(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/UpdateColor", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductFilterColor(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/FilterColor", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

//Color

//Berand

export async function ProductFilterBerand(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/FilterBerand", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductDeleteBerand(id) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/Product/DeleteBerand/" + id,
      undefined,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductCreateBerand(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/CreateBerand", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductUpdateBerand(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/UpdateBerand", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ProductChangeOrderBerand(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Product/ChangeOrderBerand", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

//Berand

//Product

////////////////////////////////////////////////////////////////////////////////////////////

//Competitor
export async function CompetitorFilterCompetitor(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Competitor/FilterCompetitor", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorDeleteCompetitor(id) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/Competitor/DeleteCompetitor/" + id,
      undefined,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorIsShowCompetitor(id) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/Competitor/IsShowCompetitor/" + id,
      undefined,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorChangeIsAceess(id) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/Competitor/ChangeIsAceess/" + id,
      undefined,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorIsAutoCompetitor(id) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/Competitor/IsAutoCompetitor/" + id,
      undefined,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorUpdateCompetitor(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Competitor/UpdateCompetitor", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorChangeOrderCompetitor(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post(
      "/Competitor/ChangeOrderCompetitor",
      data,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorCreateCompetitor(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Competitor/CreateCompetitor", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorMyCompetitor() {
  let header = getHeader();
  try {
    const response = await client.get("/Competitor/MyCompetitor", {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
export async function CompetitorMyCompetitorCategory() {
  let header = getHeader();
  try {
    const response = await client.get("/Competitor/MyCompetitorCategory", {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ShowMarketGet() {
  let header = getHeader();
  try {
    const response = await client.get("/ShowMarket/Get", {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorLstCompetitor() {
  let header = getHeader();
  try {
    const response = await client.get("/Competitor/LstCompetitor", {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

//Competitor

//Category

export async function CompetitorFilterCategory(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Competitor/FilterCategory", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorGetIdentityCategory(id) {
  let header = getHeader();

  try {
    const response = await client.get("/Competitor/GetIdentityCategory/" + id, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorDeleteCategory(id) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/Competitor/DeleteCategory/" + id,
      undefined,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorUpdateCategory(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Competitor/UpdateCategory", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorChangeOrderCategory(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post(
      "/Competitor/ChangeOrderCategory",
      data,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorSetIdentityCategory(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post(
      "/Competitor/SetIdentityCategory",
      data,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorCreateCategory(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Competitor/CreateCategory", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorLstCategory() {
  let header = getHeader();
  try {
    const response = await client.get("/Competitor/LstCategory", {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

//Category

//Competitor

////////////////////////////////////////////////////////////////////////////////////////////

//CompetitorPrice

export async function CompetitorPriceLastPrice(id) {
  let header = getHeader();

  try {
    const response = await client.get("/CompetitorPrice/LastPrice/" + id, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorPriceSetAmount(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/CompetitorPrice/SetAmount", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorPriceHistory(id) {
  let header = getHeader();

  try {
    const response = await client.get("/CompetitorPrice/History/" + id, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorPriceSetRefProduct(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/CompetitorPrice/SetRefProduct", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorPriceEditeAmount(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/CompetitorPrice/EditeAmount", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorPriceHistoryDate(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/CompetitorPrice/HistoryDate", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorPriceGetProdctGhosh(id) {
  let header = getHeader();

  try {
    const response = await client.get("/CompetitorPrice/GetProdctGhosh/" + id, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorPriceGetProductAuto(id) {
  let header = getHeader();

  try {
    const response = await client.get("/CompetitorPrice/GetProductAuto/" + id, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

//CompetitorPrice

////////////////////////////////////////////////////////////////////////////////////////////
//CompetitorPackeage

export async function CompetitorPackeageDeleteCompanyPackeage(id) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/CompetitorPackeage/DeleteCompanyPackeage/" + id,
      null,
      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorPackeagePackeageToList(id) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/CompetitorPackeage/PackeageToList/" + id,
      null,
      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorPackeageFilterCompanyPackeage(id) {
  let header = getHeader();

  try {
    const response = await client.get(
      "/CompetitorPackeage/FilterCompanyPackeage/" + id,
      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorPackeageFilterCompanyPackeageBy(id) {
  let header = getHeader();

  try {
    const response = await client.get(
      "/CompetitorPackeage/FilterCompanyPackeageBy/" + id,
      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorPackeageHistoryPackeage(id) {
  let header = getHeader();

  try {
    const response = await client.get(
      "/CompetitorPackeage/HistoryPackeage/" + id,
      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorPackeageSetAmountPackeage(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post(
      "/CompetitorPackeage/SetAmountPackeage",
      data,
      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompetitorPackeageEditeAmountPackeage(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post(
      "/CompetitorPackeage/EditeAmountPackeage",
      data,
      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

//CompetitorPackeage

////////////////////////////////////////////////////////////////////////////////////////////

//Company

//Company
export async function CompanyFilterCompany(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Company/FilterCompany", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompanyGetIdentityCompany(id) {
  let header = getHeader();

  try {
    const response = await client.get("/Company/GetIdentityCompany/" + id, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompanyDeleteCompany(id) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/Company/DeleteCompany/" + id,
      undefined,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompanyUpdateCompany(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Company/UpdateCompany", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompanySetIdentityCompany(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Company/SetIdentityCompany", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompanyCreateCompany(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Company/CreateCompany", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompanyChangeOrderCompany(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Company/ChangeOrderCompany", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

//Company

////////////////////////////////////////////////////////////////////////////////////////////

//warehouse

export async function CompanyCreateWarehouse(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Company/CreateWarehouse", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompanyUpdateWarehouse(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Company/UpdateWarehouse", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompanyDeleteWarehouse(id) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/Company/DeleteWarehouse/" + id,
      undefined,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompanyFilterWarehouse(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Company/FilterWarehouse", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

//warehouse

//SmsSetting

export async function SmsSettingCreateSmsSetting(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/SmsSetting/CreateSmsSetting", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SmsSettingUpdateSmsSetting(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/SmsSetting/UpdateSmsSetting", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SmsSettingDeleteSmsSetting(id) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/SmsSetting/DeleteSmsSetting/" + id,
      undefined,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SmsSettingFilterSmsSetting(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/SmsSetting/FilterSmsSetting", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

//SmsSetting
//ServiceOut

export async function ServiceOutCreateServiceOut(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/ServiceOut/CreateServiceOut", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ServiceOutUpdateServiceOut(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/ServiceOut/UpdateServiceOut", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ServiceOutDeleteServiceOut(id) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/ServiceOut/DeleteServiceOut/" + id,
      undefined,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ServiceOutFilterServiceOut(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/ServiceOut/FilterServiceOut", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

//SmsSetting

//Setting

export async function SettingCreateSetting(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Setting/CreateSetting", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SettingUpdateSetting(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Setting/UpdateSetting", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SettingDeleteSetting(id) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/Setting/DeleteSetting/" + id,
      undefined,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SettingFilterSetting(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Setting/FilterSetting", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

//Setting

//EmailSetting

export async function EmailSettingGetEmailSetting() {
  let header = getHeader();

  try {
    const response = await client.get("/EmailSetting/GetEmailSetting", {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function EmailSettingSetEmailSetting(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/EmailSetting/SetEmailSetting", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

//EmailSetting
//Info

export async function InfoGetInfo() {
  try {
    const response = await client.get("/Info/GetInfo", {});
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function InfoSetInfo(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Info/SetInfo", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

//Info

//Company

export async function CompanyFilterCompanyStore(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Company/FilterCompanyStore", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompanyGetIdentityCompanyStore(id) {
  let header = getHeader();

  try {
    const response = await client.get(
      "/Company/GetIdentityCompanyStore/" + id,
      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompanyGetCompanyStoreCompetitor(id) {
  let header = getHeader();

  try {
    const response = await client.get(
      "/Company/GetCompanyStoreCompetitor/" + id,
      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompanyDeleteCompanyStore(id) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/Company/DeleteCompanyStore/" + id,
      undefined,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompanyUpdateCompanyStore(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Company/UpdateCompanyStore", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompanySetIdentityCompanyStore(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post(
      "/Company/SetIdentityCompanyStore",
      data,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompanySetCompanyStoreCompetitor(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post(
      "/Company/SetCompanyStoreCompetitor",
      data,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompanyCreateCompanyStore(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Company/CreateCompanyStore", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompanyChangeOrderCompanyStore(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post(
      "/Company/ChangeOrderCompanyStore",
      data,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

//Company

////////////////////////////////////////////////////////////////////////////////////////////

//CompanyManage
export async function CompanyManageMyStore() {
  let header = getHeader();
  try {
    const response = await client.get(
      "/CompanyManage/MyStore",

      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
export async function CompanyManageMyStoreMyStoreCompany(id) {
  let header = getHeader();
  try {
    const response = await client.get(
      "/CompanyManage/MyStoreCompany/" + id,

      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompanyManageMyCompany() {
  let header = getHeader();
  try {
    const response = await client.get(
      "/CompanyManage/MyCompany",

      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

//CompanyProdcut
export async function CompanyManageSetProductCompany(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post(
      "/CompanyManage/SetProductCompany",
      data,
      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompanyManageGetProductCompany(id) {
  let header = getHeader();
  try {
    const response = await client.get(
      "/CompanyManage/GetProductCompany/" + id,

      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

//CompanyProdcut

//CompanyStoreStock
export async function CompanyManageSetCompanyStoreStock(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post(
      "/CompanyManage/SetCompanyStoreStock",
      data,
      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompanyManageGetCompanyStoreStock(id) {
  let header = getHeader();
  try {
    const response = await client.get(
      "/CompanyManage/GetCompanyStoreStock/" + id,

      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompanyManageGetCompanyStoreStockByColor(id) {
  let header = getHeader();
  try {
    const response = await client.get(
      "/CompanyManage/GetCompanyStoreStockByColor/" + id,

      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompanyManageGetAutoStock(id) {
  let header = getHeader();
  try {
    const response = await client.get("/CompanyManage/GetAutoStock/" + id, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

//CompanyStoreStock

//CompanyStoreAvrageRate

export async function CompanyManageSetCompanyStoreAvrageRate(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post(
      "/CompanyManage/SetCompanyStoreAvrageRate",
      data,
      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompanyManageGetCompanyStoreAvrageRate(id) {
  let header = getHeader();
  try {
    const response = await client.get(
      "/CompanyManage/GetCompanyStoreAvrageRate/" + id,

      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function CompanyManageGetAutoAvrageRate(id) {
  let header = getHeader();
  try {
    const response = await client.get(
      "/CompanyManage/GetAutoAvrageRate/" + id,

      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
export async function CompanyManageGetStockAll() {
  let header = getHeader();
  try {
    const response = await client.get(
      "/CompanyManage/GetStockAll",

      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

//CompanyStoreAvrageRate

////////////////////////////////////////////////////////////////////////////////////////////

//CompanyManage

////////////////////////////////////////////////////////////////////////////////////////////

//OfferPrice

export async function OfferPriceGetBaseData(id) {
  let header = getHeader();
  try {
    const response = await client.get(
      "/OfferPrice/GetBaseData/" + id,

      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function OfferPriceSetPriceOffer(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post("/OfferPrice/SetPriceOffer", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function OfferPriceHistoryPriceOffer(id) {
  let header = getHeader();
  try {
    const response = await client.get(
      "/OfferPrice/HistoryPriceOffer/" + id,

      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
//OfferPrice
////////////////////////////////////////////////////////////////////////////////////////////
//Price

export async function PriceGetBaseDataPriceForUpdate(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post(
      "/Price/GetBaseDataPriceForUpdate",
      data,
      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function PriceGetBaseDataPrice() {
  let header = getHeader();
  try {
    const response = await client.get(
      "/Price/GetBaseDataPrice",

      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function PriceSetPrice(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Price/SetPrice", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function PriceHistoryPrice(model) {
  let header = getHeader();
  let data = JSON.stringify(model);

  try {
    const response = await client.post("/Price/HistoryPrice", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function PriceGetGroupPrice() {
  let header = getHeader();
  try {
    const response = await client.get(
      "/Price/GetGroupPrice",

      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function PriceListPrice(id) {
  let header = getHeader();
  try {
    const response = await client.get(
      "/Price/ListPrice/" + id,

      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

//Price
///////////////////////////////////////////////////////////////////////////////////////////
//Site

export async function SiteGetMyStoreSite() {
  let header = getHeader();
  try {
    const response = await client.get("/Site/GetMyStoreSite", {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SiteGetProductSite(id) {
  let header = getHeader();
  try {
    const response = await client.get("/Site/GetProductSite/" + id, {
      headers: header,
    });
    return response;
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SiteLogin(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Site/Login", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SiteSetStocks(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Site/SetStocks", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SiteSetPrices(id) {
  let header = getHeader();
  try {
    const response = await client.post("/Site/SetPrices/" + id, undefined, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
//Site
///////////////////////////////////////////////////////////////////////////////////////////

export async function FetchIdentity(id) {
  let header = getHeader();

  try {
    const response = await client.get("/Identity/FetchAccessUser/" + id, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function FetchMyAccess() {
  let header = getHeader();

  try {
    const response = await client.get("/Identity/FetchMyAccess", {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function ApplyIdentity(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Identity/ApplyAccessUser", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
export async function CompetitorSetIdentityCompetitorUser(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post(
      "/Competitor/SetIdentityCompetitorUser",
      data,
      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
export async function CompetitorSetIdentityUserCompetitor(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post(
      "/Competitor/SetIdentityUserCompetitor",
      data,
      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
export async function CompetitorGetProductCompetitor(id) {
  let header = getHeader();
  try {
    const response = await client.get(
      "/Competitor/GetProductCompetitor/" + id,

      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}
export async function CompetitorSetProductCompetitor(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post(
      "/Competitor/SetProductCompetitor",
      data,
      {
        headers: header,
      }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function GetSiteSearch(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Site/Filter", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function GetStorePrice() {
  let header = getHeader();

  try {
    const response = await client.get("/Price/HistoryPrice", {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function GetPriceCompetitorSearch() {
  let header = getHeader();

  try {
    const response = await client.get("/PriceCompetitor/Filter", {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SetPriceCompetitor(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/PriceCompetitor/Create", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SetPriceStore(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/PriceStore/Create", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SetPrice(model) {
  let header = getHeader();
  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Price/SetPrice", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SetStockSite(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Site/SetStocks", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SetPriceSite() {
  let header = getHeader();
  try {
    const response = await client.post("/Site/SetPrices", null, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function EditeAmount(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/CompetitorPrice/EditeAmount", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SetAverageRate(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/AverageRate/SetAverageRate", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function DeleteSite(id) {
  let header = getHeader();

  try {
    const response = await client.post("/Site/Delete/" + id, undefined, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function UpdateSite(model, id) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Site/Update/" + id, data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function UsersChangeActiveSite(id, Status) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/Site/UsersChangeActive/" + id + "?Status=" + Status,
      undefined,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function AddSite(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Site/Create", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function GetStoreSearch(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Store/Filter", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function GetCategorySearch(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post(
      "/CompetitorCategory/FilterCategory",
      data,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function GetIdentityStore(id) {
  let header = getHeader();

  try {
    const response = await client.get("/Store/GetIdentityStore/" + id, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function GetCompetitorStore(id) {
  let header = getHeader();

  try {
    const response = await client.get("/Store/GetCompetitorStore/" + id, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function GetAverageRate() {
  let header = getHeader();

  try {
    const response = await client.get("/AverageRate/GetAverageRate", {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function UpdateSynic() {
  let header = getHeader();

  try {
    const response = await client.get("/SyncNamad/GetDataNamad", {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function GetLastSynic() {
  let header = getHeader();

  try {
    const response = await client.get("/SyncNamad/GetLastSyncNamad", {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function GetProductPrice() {
  let header = getHeader();
  try {
    const response = await client.get("/Price/GetProductPrice", {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function HistoryPriceOfferForPrice() {
  let header = getHeader();
  try {
    const response = await client.get("/PriceOffer/HistoryPriceOfferForPrice", {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function GetProductPriceOffer() {
  let header = getHeader();
  try {
    const response = await client.get("/PriceOffer/GetProductPriceOffer", {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function GetProductSitePrices() {
  let header = getHeader();
  try {
    const response = await client.get("/Site/GetProductSitePrices", {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function GetProductSiteStock() {
  let header = getHeader();
  try {
    const response = await client.get("/Site/GetProductSiteStock", {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function GetProductCompetitor(CodeStore) {
  let header = getHeader();
  try {
    const response = await client.get(
      "/CompetitorPrice/GetProduct/" + CodeStore,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function DataEditeAmount(model) {
  let header = getHeader();
  let data = JSON.stringify(model);
  try {
    const response = await client.post(
      "/CompetitorPrice/DataEditeAmount",
      data,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SetConnectProduct(model) {
  let header = getHeader();
  let data = JSON.stringify(model);
  try {
    const response = await client.post("/Site/SetConnectProduct", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function GetBaseAverageRate(id) {
  let header = getHeader();
  try {
    const response = await client.get("/AverageRate/GetBaseAverageRate/" + id, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function DeleteBasicProduct(id) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/BasicProduct/Delete/" + id,
      undefined,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function DeleteStore(id) {
  let header = getHeader();

  try {
    const response = await client.post("/Store/Delete/" + id, undefined, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SiteLoginService(model) {
  let header = getHeader();
  let data = JSON.stringify(model);

  try {
    const response = await client.post("/Site/Login", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function UsersChangeActiveBasicProductInformation(id, Status) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/BasicProductInformation/UsersChangeActive/" + id + "?Status=" + Status,
      undefined,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function UsersChangeActiveStore(id, Status) {
  let header = getHeader();

  try {
    const response = await client.post(
      "/Store/UsersChangeActive/" + id + "?Status=" + Status,
      undefined,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function UpdateBasicProduct(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/BasicProduct/Update/", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function UpdateStore(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Store/Update", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SetIdentityStore(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Store/SetIdentityStore", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SetCompetitorStore(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Store/SetCompetitorStore", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function AddBasicProduct(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post(
      "/BasicProduct/Create/" + competitor,
      null,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function AddStore(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Store/Create", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function GetVarietySearch(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Variety/Filter", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function DeleteVariety(id) {
  let header = getHeader();

  try {
    const response = await client.post("/Variety/Delete/" + id, undefined, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function UpdateVariety(model, id) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Variety/Update/" + id, data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function AddVariety(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/Variety/Create", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function GetLastPrice() {
  let header = getHeader();

  try {
    const response = await client.get("/Price/LastPrice", { headers: header });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function PriceLastDayOfOffer() {
  let header = getHeader();

  try {
    const response = await client.get("/Price/PriceLastDayOfOffer", {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function HistoryPriceStore(id) {
  let header = getHeader();

  try {
    const response = await client.get("/Price/HistoryPriceStore/" + id, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function BasicProductPriceHistory() {
  let header = getHeader();

  try {
    const response = await client.get("/BasicProductPrice/History", {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function UpdateAllStock(model) {
  let header = getHeader();

  try {
    let data = JSON.stringify(model);
    const response = await client.post("/StockExonOld/UpdateAllStock", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function GetPriceStoreNeed() {
  let header = getHeader();

  try {
    const response = await client.get("/PriceStore/NeedCreate", {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function GetChartPrice(model) {
  let header = getHeader();
  let data = JSON.stringify(model);
  try {
    const response = await client.post("/Price/Filter", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function GetCharVarietyt(id, Day) {
  let header = getHeader();
  try {
    const response = await client.get(
      "/Price/CharVarietyt/" + id + "?LastDay=" + Day,
      { headers: header }
    );
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function GetChangePrice(model) {
  let header = getHeader();
  let data = JSON.stringify(model);
  try {
    const response = await client.post("/PriceExonOld/FilterPrice", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SetChangePrice(model) {
  let header = getHeader();
  let data = JSON.stringify(model);
  try {
    const response = await client.post("/PriceExonOld/UpdatePrice", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function GetChangeStock(model) {
  let header = getHeader();
  let data = JSON.stringify(model);
  try {
    const response = await client.post("StockExonOld/FilterStock", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SetChangeStock(model) {
  let header = getHeader();
  let data = JSON.stringify(model);
  try {
    const response = await client.post("StockExonOld/UpdateStock", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

export async function SetChangeStockAll(Mode) {
  let header = getHeader();
  let data = JSON.stringify({ mode: Mode });
  try {
    const response = await client.post("StockExonOld/UpdateAllStock", data, {
      headers: header,
    });
    return SuccessHandel(response);
  } catch (error) {
    return ErrorHandel(error);
  }
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const ErrorHandel = (error) => {
  if (error.response === undefined) {
    toast.error("undefined Error");
    // Unauthorized();
  } else {
    if (error.response.status === 400) {
      toast.error(error.response.data.message);
    } else {
      if (error.response.status === 403) {
        toast.error("Forbidden");
        Forbidden();
      } else {
        if (error.response.status === 401) {
          toast.error("Unauthorized");
          Unauthorized();
        } else {
          toast.error("Server Error");
        }
      }
    }
  }
};

const SuccessHandel = (data) => {
  let copyData = data;
  if (!data.data.isSuccess) {
    copyData.status = 400;
    toast.error(data.data.message);
  }
  return copyData;
};

const Unauthorized = () => {
  localStorage.removeItem("Identity");
  localStorage.removeItem("Username");
  localStorage.removeItem("CompanyUserName");
  localStorage.removeItem("Token");
  window.location.href = "/login";
  // const navigate = useNavigate();
  // navigate("/login");
};
const Forbidden = () => {
  const navigate = useNavigate();
  navigate("/panel");
};
